const niceType = (typeName) => typeName.replace(/^.*\.(.*?)$/, "$1");
const functionSignature = (descriptor) => {
  const args = descriptor.params.map((p) => p.optional ? `[${p.name}]` : p.name);
  return `${descriptor.name}(${args.join(", ")}) : ${niceType(descriptor.return_type)}`;
};
export { functionSignature, niceType };
